var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M21.533 7.112c.015.213.015.426.015.64 0 6.502-4.949 13.994-13.995 13.994A13.9 13.9 0 0 1 0 19.538c.396.046.777.061 1.188.061 2.3 0 4.416-.777 6.106-2.101a4.93 4.93 0 0 1-4.599-3.412c.305.046.61.076.93.076a5.2 5.2 0 0 0 1.294-.167A4.92 4.92 0 0 1 .975 9.168v-.061a4.95 4.95 0 0 0 2.223.624 4.92 4.92 0 0 1-2.193-4.096c0-.914.244-1.752.67-2.483A13.98 13.98 0 0 0 11.817 8.3a5.6 5.6 0 0 1-.122-1.127 4.917 4.917 0 0 1 4.92-4.92c1.415 0 2.695.595 3.593 1.554A9.7 9.7 0 0 0 23.33 2.62a4.9 4.9 0 0 1-2.163 2.711A9.9 9.9 0 0 0 24 4.569a10.6 10.6 0 0 1-2.467 2.543"
  })));
};
export default SvgTwitter;